import { render, staticRenderFns } from "./StarLine.vue?vue&type=template&id=87592f7e&scoped=true&"
import script from "./StarLine.vue?vue&type=script&lang=js&"
export * from "./StarLine.vue?vue&type=script&lang=js&"
import style0 from "./StarLine.vue?vue&type=style&index=0&id=87592f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87592f7e",
  null
  
)

export default component.exports